import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/** Panel derecho compartido (desktop) para todas las vistas de authentication. */
@Component({
  selector: 'app-auth-showcase-aside',
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'auth-showcase-aside-host',
  },
  template: `
    <aside class="auth-showcase auth-showcase--brand" aria-hidden="true">
      <div class="auth-showcase__inner">
        <div class="auth-showcase__mockup">
          <div class="auth-showcase__mockup-bar">
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
          </div>
          <div class="auth-showcase__mockup-body">
            <img
              src="/assets/images/logos/logo-icon.svg"
              class="auth-showcase__mockup-logo"
              alt=""
            />
            <span class="auth-showcase__mockup-chip">{{ 'auth.showcase.chip' | translate }}</span>
          </div>
        </div>

        <div class="auth-showcase__slides">
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide1Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide1Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide2Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide2Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide3Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide3Body' | translate }}</p>
          </div>
        </div>

        <div class="auth-showcase__dots" aria-hidden="true">
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
        </div>
      </div>
    </aside>
  `,
})
export class AuthShowcaseAsideComponent {}
